import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {Constants} from '../../rules/constants';
import {FormControl} from '@angular/forms';
import {HttpService} from '../../auth/http.client.service';
import {environment} from '../../../environments/environment';
import {AuthService} from '../../auth/auth.service';
import {DropDownOption} from '../../rules/new-rule/condition-col/condition-col.component';

@Component({
  selector: 'app-search-dropdown',
  templateUrl: './search-dropdown.component.html',
  styleUrls: ['./search-dropdown.component.scss']
})
export class SearchDropdownComponent implements OnInit, OnChanges {

  @Input() title: string = Constants.DROPDOWN_TITLE;
  @Input() isAsync: boolean;
  @Input() data = [];
  @Input() propertyName: string = Constants.NAME;
  @Input() labelName: string = Constants.DATA_TYPE;
  @Input() url: string;
  @Input() hasLabel: boolean;
  @Input() openTo: string = Constants.BOTTOM;
  @Output() selectionEvent: EventEmitter<any> = new EventEmitter<any>();
  @Input() hasError = false;
  @Input() absolute = false;
  public loading: boolean;
  public isOpen: boolean;
  public top: string = Constants.TOP;
  queryField: FormControl;

  constructor(private elemRef: ElementRef,
              private http: HttpService,
              private authService: AuthService,
              private options: DropDownOption) {
  }

  ngOnInit() {
    this.queryField = new FormControl();
    if (this.isAsync) {
      this.subscribeInputChange();
    }
    if (this.options) {
      this.configureOption();
    }
  }
  get hasSearchBox() {
    if (!this.data || this.queryField.value) {
      return true;
    }
    return this.data.length !== 1;
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['title']) {
      this.title = changes['title'].currentValue;
    }
  }

  get isLoading() {
    return this.isAsync && (!this.data || this.loading);
  }

  get fetchUrl() {
    return  `${environment.serviceBase}/accounts/${ this.authService.getCurrentAccount().id}/${this.url}`;
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.elemRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  select(item) {
    this.isOpen = false;
    this.title = item[this.propertyName];
    this.hasError = false;
    if (this.options.onSelect) {
      this.options.onSelect(item);
      return;
    }
    this.selectionEvent.emit(item);
  }

  subscribeInputChange() {
    this.queryField.valueChanges
      .debounceTime(200)
      .distinctUntilChanged()
      .switchMap((query) => { this.loading = true; return this.http.get(`${this.fetchUrl}=${query}`); })
      .subscribe(result => { this.loading = false; this.data = result.json().data.items; });
  }

  private configureOption() {
    if (!this.options) {
      return;
    }
    if (this.options.hasLabel) {
      this.hasLabel = this.options.hasLabel;
    }
    if (this.options.data) {
      this.data = this.options.data;
    }
    if (this.options.isAsync) {
      this.isAsync = this.options.isAsync;
    }
    if (this.options.propertyName) {
      this.propertyName = this.options.propertyName;
    }
    if (this.options.title) {
      this.title = this.options.title;
    }
    if (this.options.url) {
      this.url = this.options.url;
    }
    if (this.options.isAbsolute) {
      this.absolute = this.options.isAbsolute;
    }
    if (this.isAsync) {
      this.subscribeInputChange();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/search-dropdown/search-dropdown.component.ts